module.exports = __webpack_public_path__ + "public/1.0.1_701555/img/logo.9b12cbdf.svg";